import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { environment } from '@src/environments/environment';
import { IndicatorsModule } from './shared/indicators';
import { PopupsModule } from './shared/popups';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationModule } from './services';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';

import { MenuListComponent } from './components/menu-list/menu-list.component';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { HeaderComponent } from './components/header/header.component';
// import { ConnectionStatusBannerComponent } from './components/connection-status-banner/connection-status-banner.component';
import { UserStatusComponent } from './components/user-status/user-status.component';
// import { BotonNotificacionesComponent } from './components/notificaciones/boton-notificaciones.component';
import { NotificacionesModule } from './components/notificaciones/notificaciones.module';
import { WebsocketStatusModule } from './components/websocket-status/websocket-status.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers, effects } from './store';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common'; // Importa DatePipe
// import { NotificacionesModule } from './components/notificaciones/notificaciones.module';
import { MatDialogModule } from '@angular/material/dialog';
import { InactivityDialogComponent } from './components/inactivity-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuillModule } from 'ngx-quill';

// const StoreDevtools = !environment.production
//   ? StoreDevtoolsModule.instrument({ maxAge: 50 })
//   : [];

@NgModule({
  declarations: [
    AppComponent,
    MenuListComponent,
    HeaderComponent,
    UserStatusComponent,
    InactivityDialogComponent,
  ],
  imports: [
    FlexLayoutModule,
    BrowserModule,
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatTabsModule,
    MatBadgeModule,
    FormsModule,
    WebsocketStatusModule,
    NotificacionesModule,
    HttpClientModule,
    NgChartsModule,
    DragDropModule,
    ReactiveFormsModule,
    NgSelectModule,
    QuillModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase.config)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),
    AngularFireModule.initializeApp(environment.firebase.config),
    AngularFireStorageModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    IndicatorsModule,
    PopupsModule,
    NotificationModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    EffectsModule.forRoot(effects),
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
  ],
  providers: [
    DatePipe,
    AuthInterceptor, // Registrar como servicio para inyección
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
